import React from 'react';
import InlineChromiumBugfix from '../../../components/InlineChromiumBugfix';
import {
  type ComponentProps,
  type HideInlineElement,
} from '../../../types/aha-editor';

const HideInline: React.FC<ComponentProps<HideInlineElement>> = ({
  attributes,
  children,
}) => (
  <span style={{ display: 'none' }} {...attributes}>
    <InlineChromiumBugfix />
    {children}
    <InlineChromiumBugfix />
  </span>
);
export default HideInline;
